import index from './'
import reset from './reset'

export default [
  {
    path: '/forgotPassword',
    name: 'forgotpassword.index',
    component: index
  },
  {
    path: '/forgotPassword/reset',
    name: 'forgotpassword.reset',
    component: reset
  }
]



// WEBPACK FOOTER //
// ./src/features/forgotPassword/routes.js